/**
* Extensions.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2019
*/
var Extensions = /** @class */ (function () {
    function Extensions() {
    }
    Extensions.UserExt = 'user';
    Extensions.DeviceExt = 'device';
    Extensions.TraceExt = 'trace';
    Extensions.WebExt = 'web';
    Extensions.AppExt = 'app';
    Extensions.OSExt = 'os';
    Extensions.SdkExt = 'sdk';
    Extensions.IntWebExt = 'intweb';
    Extensions.UtcExt = 'utc';
    Extensions.LocExt = 'loc';
    return Extensions;
}());
export { Extensions };
//# sourceMappingURL=Extensions.js.map